import Vue from 'vue'

import SVGIcon from './../components/common/SVGIcon.vue';
import PageTitle from './../components/common/PageTitle.vue';
import AlertLoading from './../components/common/AlertLoading.vue';
import MyButton from './../components/common/MyButton.vue';
import DropdownSearch from './../components/common/DropdownSearch.vue';
import DateRangePicker from './../components/common/DateRangePicker.vue';
import Pagination from './../components/common/Pagination.vue';
import UploadFile from './../components/common/UploadFile.vue';
import Login from './../components/security/login.vue';
import NewPassword from './../components/security/newPassword.vue';
import AgreementList from './../components/customer/AgreementList.vue';
import CustomerDocumentList from './../components/customer/DocumentList.vue';
import DebtorDocumentList from './../components/debtor/DocumentList.vue';
import vueUpload from 'vue-upload-component'
import { DatePicker, Input, Form, FormItem} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/pl'
import locale from 'element-ui/lib/locale'
import Autocomplete from 'vue2-autocomplete-js'

locale.use(lang)

Vue.component('svg-icon', SVGIcon);
Vue.component('autocomplete', Autocomplete);
Vue.component('page-title', PageTitle);
Vue.component('alert-loading', AlertLoading);
Vue.component('my-button', MyButton);
Vue.component('dropdown-search', DropdownSearch);
Vue.component('date-range-picker', DateRangePicker);
Vue.component('login', Login);
Vue.component('new-password', NewPassword);
Vue.component('pagination', Pagination);
Vue.component('agreement-list', AgreementList);
Vue.component('customer-document-list', CustomerDocumentList);
Vue.component('debtor-document-list', DebtorDocumentList);
Vue.component('vue-upload', vueUpload);
Vue.component('upload-file', UploadFile);
Vue.component(DatePicker.name, DatePicker)
Vue.component(Input.name, Input)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)


// WEBPACK FOOTER //
// ./src/config/components.js